module.exports = __webpack_public_path__ + "fonts/montserrat-regular.8102c483.woff";